var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

var DocumentClient = {

	buildOpenF: function(fullPath, effectiveUserID) {
		return function(e) {
			if (e) { e.preventDefault(); }
			DocumentClient.open(fullPath, effectiveUserID);
		};
	},

	open: function(fullPath, effectiveUserID) {
		var url = WhooosReadingServices.Documents.url(fullPath);
		var params = { url: url };
		if (effectiveUserID) {
			params["effective_user_id"] = effectiveUserID;
		}
		CurrentUser.api().getDocRequest(params, $wr.apiHandler(function(response) {
			var joinChar = url.indexOf("?") > 0 ? "&" : "?";
			var tokenURL = url + joinChar + "token=" + response.token;

			var newWindow = window.open(tokenURL);
			if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') { 
				if ($wr.isSafari()) {
					window.location = tokenURL;

				} else {
					window.wrNotifications.triggerDropDownNotification({
						title: "Enable popups", 
						text: "To view this document, enable popups for whooosreading.org", 
						icon: "exclamation-sign" }, 4000);
				}
			}
			
		}.bind(this)));
	}

}

module.exports = DocumentClient;


// WEBPACK FOOTER //
// ./modules/lib/web/DocumentClient.js